import React from "react";
import { MainHeader } from "../../components";
import { Container, HStack, VStack } from "rsuite";
import { FaCircleCheck } from "react-icons/fa6";
import styles from "./WithdrawHistory.module.scss";
import { Link } from "react-router-dom";

export default function WithdrawHistory() {
  return (
    <div className={styles.withdraw__history}>
      <MainHeader title="Withdraw History" />
      <Container>
        <VStack alignItems="stretch" spacing={8} className={styles.list}>
          <HStack justifyContent="space-between">
            <div className={styles.title}>Amount</div>
            <div className={styles.title}>₹ 100.00</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Status</div>
            <div className={styles.success}>
              <FaCircleCheck size={13} color="#14d44a" />
              <span>Success</span>
            </div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Date & Time</div>
            <div className={styles.value}>10th Jun 2024, 11:45 am</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Withdraw ID</div>
            <div className={styles.value}>252363562DFt25555555</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Withdraw mode</div>
            <div className={styles.value}>UPI</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Receipt download</div>
            <Link to="/" download className={styles.download}>
              Download
            </Link>
          </HStack>
        </VStack>
        <VStack alignItems="stretch" spacing={8} className={styles.list}>
          <HStack justifyContent="space-between">
            <div className={styles.title}>Amount</div>
            <div className={styles.title}>₹ 100.00</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Status</div>
            <div className={styles.success}>
              <FaCircleCheck size={13} color="#14d44a" />
              <span>Success</span>
            </div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Date & Time</div>
            <div className={styles.value}>10th Jun 2024, 11:45 am</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Withdraw ID</div>
            <div className={styles.value}>252363562DFt25555555</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Withdraw mode</div>
            <div className={styles.value}>UPI</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Receipt download</div>
            <Link to="/" download className={styles.download}>
              Download
            </Link>
          </HStack>
        </VStack>
        <VStack alignItems="stretch" spacing={8} className={styles.list}>
          <HStack justifyContent="space-between">
            <div className={styles.title}>Amount</div>
            <div className={styles.title}>₹ 100.00</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Status</div>
            <div className={styles.success}>
              <FaCircleCheck size={13} color="#14d44a" />
              <span>Success</span>
            </div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Date & Time</div>
            <div className={styles.value}>10th Jun 2024, 11:45 am</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Withdraw ID</div>
            <div className={styles.value}>252363562DFt25555555</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Withdraw mode</div>
            <div className={styles.value}>UPI</div>
          </HStack>
          <HStack justifyContent="space-between">
            <div className={styles.value}>Receipt download</div>
            <Link to="/" download className={styles.download}>
              Download
            </Link>
          </HStack>
        </VStack>
      </Container>
    </div>
  );
}
